import React from "react";
import GroupRoutePremiumPage from "../components/GroupRoutePremiumPage";
import "./Home.css";

export const sloughToHeathrowConfigs = {
  minibus: {
    brand: "MinibusGrab",
    domain: "https://www.minibusgrab.com",
    className: "minibusgrab-v2-home",
    vehicle: "minibus",
    path: "/slough-to-heathrow-minibus",
    title: "Slough to Heathrow Minibus Hire | 8 to 16 Seater Group Transfers",
    description:
      "Book Slough to Heathrow minibus hire for families, hotels, teams and groups. 8 to 16 seater options, live Heathrow status and fixed-price quote flow.",
    keywords:
      "Slough to Heathrow minibus, Heathrow minibus Slough, 8 seater Slough to Heathrow, 16 seater Slough to Heathrow, Langley to Heathrow minibus",
    h1: "Slough to Heathrow minibus hire with live airport intelligence",
    intro:
      "Fixed-price group transfers from SL1, SL2 and SL3 to Heathrow terminals, planned with live airport, M4 route and rail disruption signals.",
    quoteLabel: "Get Minibus Quote",
    passengers: 8,
    bags: 0,
    resultPath: "/minibus-results",
    resultQuery: "vehicles=nine,fourteen",
    seats: "8 to 16 seaters",
    fleet: ["8 passenger / 9-seater minibuses", "14 to 16 passenger minibuses", "Licensed PSV partner options"],
  },
  coach: {
    brand: "CheapCoachGrab",
    domain: "https://www.cheapcoachgrab.com",
    className: "coachgrab-v2-home",
    vehicle: "coach",
    path: "/slough-to-heathrow-coach",
    title: "Slough to Heathrow Coach Hire | 25 to 53 Seater Airport Transfers",
    description:
      "Book Slough to Heathrow coach hire for schools, companies, hotels and large groups. 25 to 53 seater options, live Heathrow status and route intelligence.",
    keywords:
      "Slough to Heathrow coach, Heathrow coach hire Slough, 25 seater Slough to Heathrow, 49 seater coach Heathrow, Slough airport coach hire",
    h1: "Slough to Heathrow coach hire planned with live intelligence",
    intro:
      "Coach transfers from Slough, Langley, Burnham and nearby hotels to Heathrow, with route planning around M4 pressure, terminal status and group timing.",
    quoteLabel: "Get Coach Quote",
    passengers: 25,
    bags: 0,
    resultPath: "/coach-results",
    resultQuery: "vehicle=twentyfive",
    seats: "25 to 53 seaters",
    fleet: ["25 seater mini coach", "33 to 49 seater coaches", "53 seater high-capacity options"],
  },
};

const isSloughPickup = (value = "") => {
  const upper = String(value || "").toUpperCase();
  return upper.includes("SLOUGH") || /\bSL\d/i.test(upper);
};

const reviews = {
  minibus: [
    ["Alina V.", "Door-to-door for our Slough group was much simpler than splitting into taxis."],
    ["Martin R.", "Clear minibus quote and enough luggage space for everyone going to Heathrow."],
    ["Yasmin K.", "The Heathrow timing checks made the airport pickup feel more reliable."],
  ],
  coach: [
    ["Rachel D.", "Our Slough to Heathrow coach quote was clear and easier than arranging taxis."],
    ["Imran S.", "Good support for a larger company group, with sensible timing questions."],
    ["Claire B.", "The Heathrow status checks helped us plan a school group airport run."],
  ],
};

const proofCards = [
  {
    eyebrow: "Licensed operators",
    title: "Registered and insured",
    body: "Slough group transfers are handled by licensed private hire, minibus or PSV partners according to vehicle type.",
  },
  {
    eyebrow: "Airport aware",
    title: "Heathrow planning",
    body: "Terminal, flight, queue and road signals are considered before a group commits to the journey.",
  },
  {
    eyebrow: "Group travel",
    title: "Built around luggage",
    body: "Quotes start with vehicles sized for families, hotels, school groups, teams and event passengers.",
  },
];

const chooseCards = [
  { title: "Short route, tight timing", body: "Slough is close to Heathrow, so the biggest risk is usually terminal pressure, local pickup time or motorway disruption." },
  { title: "One vehicle for the group", body: "Avoid splitting passengers across taxis when luggage, children, colleagues or guests need to arrive together." },
  { title: "SL postcode coverage", body: "Start from Slough town centre, Langley, Burnham, Cippenham, Wexham, Colnbrook and Trading Estate pickups." },
  { title: "Fixed quote flow", body: "Enter the route once, compare available group vehicles and continue through the same booking path." },
];

const routeContentCards = [
  {
    title: "Slough pickup coverage",
    body: "Common pickups include SL1, SL2 and SL3 addresses, Slough station, Langley, Burnham, Cippenham, Wexham, Colnbrook and Slough Trading Estate.",
  },
  {
    title: "Heathrow terminal drop-offs",
    body: "Use Heathrow Airport or choose Terminal 2, 3, 4 or 5. Terminal choice can affect approach roads, unload time and meet-up planning.",
  },
  {
    title: "Group luggage planning",
    body: "For airport runs, choose a vehicle with space for suitcases, pushchairs, school bags, event kit or hotel group luggage.",
  },
  {
    title: "M4 and local road context",
    body: "The route usually uses the M4, A4 or local Heathrow roads. Live route checks help flag pressure before travel.",
  },
  {
    title: "Hotels and business groups",
    body: "Useful for Slough hotels, Trading Estate offices, Windsor-side stays and groups connecting to Heathrow flights.",
  },
  {
    title: "Minibus or coach choice",
    body: "Minibus works well for 8 to 16 passengers. For larger school, corporate or tour groups, the coach variant supports bigger vehicles.",
  },
];

const faqItems = [
  {
    question: "How long does Slough to Heathrow take by minibus?",
    answer: "Many Slough to Heathrow journeys are around 15 to 30 minutes, but terminal choice, M4 traffic, pickup loading and time of day can change the plan.",
  },
  {
    question: "Can we book from Langley, Burnham or Cippenham?",
    answer: "Yes. This route page supports Slough-area pickups including Langley, Burnham, Cippenham, Wexham, Colnbrook and nearby SL postcodes.",
  },
  {
    question: "Do you cover all Heathrow terminals?",
    answer: "Yes. Enter Heathrow Airport or a specific terminal. Terminal 2, 3, 4 and 5 journeys can be planned through the quote flow.",
  },
  {
    question: "Should we choose a minibus or coach?",
    answer: "Use a minibus for typical 8 to 16 passenger groups. For 25+ passengers, use the Slough to Heathrow coach route so the quote starts with larger vehicle options.",
  },
];

export const sloughToHeathrowGroupRouteTemplate = {
  routeKey: "slough",
  liveStripVariant: "slough",
  pageClassName: "slough-heathrow-v2",
  heroEyebrow: "Slough to Heathrow route",
  metrics: ["SL1, SL2, SL3", "15-30 min typical", "__SEATS__", "M4 + Heathrow live checks"],
  areas: ["Slough", "Langley", "Burnham", "Heathrow Airport"],
  seo: {
    routeName: "Slough to Heathrow group transfer",
    serviceType: "Heathrow group airport transfer",
    areaServed: ["Slough", "Langley", "Burnham", "Heathrow Airport"],
  },
  trustCards: [
    {
      eyebrow: "GOV.UK registered",
      title: "Licensed operators",
      body: "Licensed and insured partners for group airport journeys.",
    },
    {
      eyebrow: "Live Heathrow status",
      title: "Road, rail, flight and queues",
      body: "Route context is shown before the booking decision.",
    },
  ],
  quote: {
    formId: "slough-heathrow-route-quote",
    pickupDefault: "Slough, SL1",
    dropoffDefault: "Heathrow Airport",
    pickupAriaLabel: "Slough pickup postcode or address",
    dropoffAriaLabel: "Heathrow drop-off postcode or terminal",
    pickupPlaceholder: "Enter Slough pickup postcode or address",
    dropoffPlaceholder: "Enter Heathrow terminal or dropoff",
    validatePickup: isSloughPickup,
    pickupError: "This route page is for Slough pickups. Please use an SL postcode or Slough address.",
    genericError:
      "We could not calculate a quote for this Slough to Heathrow journey. Please check the details and try again.",
  },
  compactStatusTitle: "Slough to Heathrow checks",
  detailedStatusTitle: (vehicleLabel) => `Heathrow checks for Slough to Heathrow ${vehicleLabel} journeys`,
  detailedStatusIntro:
    "Roads, rail, flights, terminal pressure, queues and weather are grouped into a practical preview before the group commits to a quote.",
  reviews,
  proofCards,
  chooseTitle: "Built for Slough groups heading to Heathrow",
  chooseCards,
  routeContentCards,
  faqItems,
  pricePreviewTitle: (vehicle) => `Slough to Heathrow ${vehicle} previews`,
  routeOverviewTitle: "Slough to Heathrow route notes",
  routeOverviewIntro:
    "Slough is close to Heathrow, but terminal choice, M4 traffic, group luggage and pickup timing still matter. This page keeps the route specific so users can understand the journey before they quote.",
  vehicleContextTitle: (brand) => `${brand} options for Slough to Heathrow`,
  faqEyebrow: "Slough / LHR FAQ",
  faqTitle: "Common questions before booking",
  support: {
    title: "Need help planning a Slough to Heathrow group transfer?",
    body:
      "Use the quote form first, or contact support for multi-stop, hotel, school, event or luggage-heavy journeys.",
  },
};

export const GroupRoutePremiumPageForSlough = ({ variant = "minibus", route = sloughToHeathrowGroupRouteTemplate }) => (
  <GroupRoutePremiumPage variant={variant} route={route} configs={sloughToHeathrowConfigs} />
);

export default GroupRoutePremiumPageForSlough;
